<template>
  <div>
    <b-modal size="lg" centered id="bv-modal-example" hide-footer>
      <template #modal-title>
        <span class="text-success">Create trainer</span>
      </template>
      <div class="d-block">
        <form action="">
          <div class="form-row">
            <div class="col-6">
              <label for="form_no">Name<span class="c-required">*</span></label>
              <input type="text" v-model="form.desc" v-validate="'required'" id="form_no" name="name"
                class="form-control form-control-sm" placeholder="Trainer name" />
              <div class="invalid-feedback">
                Please enter name.
              </div>
            </div>

            <div class="col-6">
              <label for="form_no">Designation<span class="c-required">*</span></label>
              <input type="text" v-model="form.designation" v-validate="'required'" id="form_no" name="designation"
                class="form-control form-control-sm" placeholder="Trainer designation" />
              <div class="invalid-feedback">
                Please enter name.
              </div>
            </div>
          </div>

          <div class="form-row mt-1">
            <div class="col-6">
              <label for="form_no">Mobile<span class="c-required">*</span></label>
              <input type="text" v-model="form.mobile" v-validate="'required|numeric'" id="form_no" name="mobile"
                class="form-control form-control-sm" placeholder="Enter mobile" />
              <div class="invalid-feedback">
                Please enter mobile.
              </div>
            </div>

            <div class="col-6">
              <label for="form_no">Email<span class="c-required">*</span></label>
              <input type="email" v-model="form.email" v-validate="'required'" id="form_no" name="mobile"
                class="form-control form-control-sm" placeholder="Enter email" />
              <div class="invalid-feedback">
                Please enter email.
              </div>
            </div>
          </div>
          <div class="form-row mt-1">
            <div class="col-6">
              <label for="form_no">Nid<span class="c-required">*</span></label>
              <input type="text" v-model="form.nid" v-validate="'required'" id="form_no" name="mobile"
                class="form-control form-control-sm" placeholder="Enter nid" />
              <div class="invalid-feedback">
                Please enter nid.
              </div>
            </div>
            <div class="col-6">
              <label for="form_no">Address<span class="c-required">*</span></label>
              <input type="text" v-model="form.address" v-validate="'required'" id="form_no" name="address"
                class="form-control form-control-sm" placeholder="Enter address" />
              <div class="invalid-feedback">
                Please enter address.
              </div>
            </div>
          </div>

          <div class="form-row mt-1">
            <div class="col-6">
              <label for="form_no">Education<span class="c-required">*</span></label>
              <input type="text" v-model="form.education" v-validate="'required'" id="form_no" name="mobile"
                class="form-control form-control-sm" placeholder="Enter education" />
              <div class="invalid-feedback">
                Please enter education.
              </div>
            </div>
            <div class="col-6">
              <label for="form_no">Expertise<span class="c-required">*</span></label>
              <input type="text" v-model="form.expertise" v-validate="'required'" id="form_no" name="mobile"
                class="form-control form-control-sm" placeholder="Enter expertise" />
              <div class="invalid-feedback">
                Please enter education.
              </div>
            </div>

            <div class="col-12 mt-1">
              <div class="form-group">
                <label for="exampleFormControlSelect1">Select trade <span class="c-required">*</span></label>
                <!-- <select v-validate="'required'" v-model="form.c_training_trade_id" class="form-control form-control-sm"
                  id="exampleFormControlSelect1">
                  <option v-for="trade in trades" :value="trade.id">{{ trade.desc }}</option>
                </select> -->

                <multiselect v-model="form.c_training_trades" :options="trades" track-by="id" label="desc"
                  :multiple="true"></multiselect>
              </div>
            </div>
          </div>

          <div class="form-row mt-1">
            <div class="col-12">
              <button v-if="!btn_edit" class="btn btn-sm btn-success" @click.prevent="save">Submit</button>
              <button v-else class="btn btn-sm btn-success" @click.prevent="update">Update</button>
            </div>
          </div>
        </form>
      </div>
    </b-modal>
  </div>
</template>

<script>
import http from "@state/http";
import Multiselect from 'vue-multiselect'

export default {
  props: ['data', 'btn_edit'],
  components: {
    Multiselect
  },
  data() {
    return {
      form: {},
      trades: [],
    }
  },
  mounted() {
    this.getData()
  },
  watch: {
    data(newData, old) {
      this.form = newData
    }
  },
  methods: {
    getData() {
      http.get("api/trades/all").then(response => {
        if (!response.error) {
          this.trades = response.data
        }
      });
    },
    save() {
      this.$validator.validate().then(valid => {
        if (valid) {
          http.post("api/trainers/store", this.form).then(response => {
            if (!response.error) {
              this.$bvModal.hide('bv-modal-example')
              this.$bvToast.toast('Added a new trainer', {
                title: "Success",
                autoHideDelay: 5000,
                variant: "success"
              });
              this.$emit('getData')
            }
          });
        }
      })
    },
    update() {
      this.$validator.validate().then(valid => {
        if (valid) {
          http.post("api/trainers/update/" + this.data.id, this.form).then(response => {
            if (!response.error) {
              this.$bvModal.hide('bv-modal-example')
              this.$bvToast.toast('Updated the trainer', {
                title: "Success",
                autoHideDelay: 5000,
                variant: "success"
              });
              this.$emit('getData')
            }
          });
        }
      })
    }
  }

}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>